<template>
  <div class="job">
    <div v-if="job !== null && jobNotFound === false" class="job-content">
      <router-link :to="{ name: 'index', query: { clearJobId: true } }" style="white-space: nowrap;" class="action-link mb-4">
        <span><img src="@/assets/arrow-left-short.svg"></span>
        <span class="text">Tillbaka till jobblistan</span>
      </router-link>

      <img v-if="job.media.top_image" @load="updateHeight()" :src="job.media.top_image" class="img-fluid top-image">

      <hr class="mt-0">

      <section class="d-flex align-items-start justify-content-between mt-4 flex-wrap">
        <h2 class="font-bold">{{ job.title.replace('/', '/&shy;') }}</h2>
      </section>

      <section class="mt-4" v-html="job.description"></section>

      <section class="conditions">
        <h3 class="mt-4">Anställning</h3>

        <ul class="list-unstyled">
          <li><strong>Anställningsform:</strong> {{ job.details['employment-type']?.text || '-' }}</li>
          <li><strong>Omfattning:</strong> {{ job.details['employment-hours']?.text || '-' }}</li>
          <li><strong>Lön:</strong> {{ job.details['pay']?.text || '-' }}</li>
          <li><strong>Tillträde:</strong> {{ job.details['admission']?.text || '-' }}</li>
          <li><strong>Antal jobb:</strong> {{ job.details['positions']?.text || '-' }}</li>
          <!-- TODO: Check with Grade why the "Varaktighet t.o.m" field is missing in the API -->
          <!-- <li v-if="typeof job.projectends === 'string' && job.projectends.trim().length > 0"><strong>Varaktighet t.o.m:</strong> {{ job.projectends }}</li> -->
          <li v-if="job.details['driving_licenses']"><strong>Körkortskrav:</strong> {{ job.details['driving_licenses'].text }}</li>
        </ul>
      </section>

      <section v-if="job.links.apply">
        <h3 class="mt-4">Ansökan</h3>

        <a :href="job.links.apply" target="_none" class="sol-btn">Ansök här</a>
      </section>

      <section>
        <h3 class="mt-4">Ansök senast</h3>

        <ul class="list-unstyled">
          <li><strong>Sista ansökningsdag:</strong> {{ job.details.deadline ? job.details.deadline.text : '-' }}</li>
        </ul>
      </section>

      <section>
        <h3 class="mt-4">Referensnummer</h3>

        <p>{{ job.details.reference.text }}</p>
      </section>

      <section>
        <h3 class="mt-4">Kontaktperson(er)</h3>

        <ul class="list-unstyled">
          <li class="mt-1" v-for="contact in job.contacts" :key="contact.name">{{ contact.name + ', ' + contact.phone }}</li>
        </ul>
      </section>

      <section v-if="job.union_contacts.length > 0">
        <h3 class="mt-4">Facklig(a) företrädare</h3>

        <ul class="list-unstyled">
          <li v-for="contact in job.union_contacts" :key="contact.name">{{ contact.name + ', ' + contact.phone }}</li>
        </ul>
      </section>

      <section>
        <h3 class="mt-4">Dela</h3>

        <div class="share-icons">
          <a :href="'https://www.facebook.com/sharer/sharer.php?u=https://regiongotland.varbi.com/what:job/jobID:' + job.id" target="_blank" rel="noopener noreferrer" aria-label="Dela på Facebook" title="Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
              <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/>
            </svg>
          </a>

          <a :href="'https://x.com/share?url=https://regiongotland.varbi.com/what:job/jobID:' + job.id + '/&text='" target="_blank" rel="noopener noreferrer" aria-label="Dela på X" title="X (Twitter)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
            </svg>
          </a>

          <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=https://regiongotland.varbi.com/what:job/jobID:' + job.id" target="_blank" rel="noopener noreferrer" aria-label="Dela på Linkedin" title="Linkedin">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/>
            </svg>
          </a>

          <a :href="'whatsapp://send/?text=https://regiongotland.varbi.com/what:job/jobID:' + job.id" target="_blank" rel="noopener noreferrer" aria-label="Dela på Whatsapp" title="Whatsapp">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
            </svg>
          </a>

          <a :href="'mailto:?subject=Jobbtips&body=https://regiongotland.varbi.com/what:job/jobID:' + job.id" target="_blank" rel="noopener noreferrer" aria-label="Dela via e-post" title="E-post">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"/>
            </svg>
          </a>
        </div>
      </section>

      <router-link :to="{ name: 'index' }" style="white-space: nowrap;" class="action-link mt-4">
        <span><img src="@/assets/arrow-left-short.svg"></span>
        <span class="text">Tillbaka till jobblistan</span>
      </router-link>
    </div>

    <div v-if="job === null && jobNotFound === true">
      <div class="job-content">
        <router-link :to="{ name: 'index', query: { clearJobId: true } }" style="white-space: nowrap;" class="action-link mb-4">
          <span><img src="@/assets/arrow-left-short.svg"></span>
          <span class="text">Tillbaka till jobblistan</span>
        </router-link>

        <p style="color: #ac3e3e; font-weight: bold;">Jobbannonsen hittades ej!</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'

export default {
  name: 'JobView',

  data () {
    return {
      job: null,
      jobNotFound: false
    }
  },

  methods: {
    ...mapActions(['sendPostMessageFrameHeight', 'sendPostMessageJobId']),

    updateHeight () {
      this.sendPostMessageFrameHeight(true)
      this.sendPostMessageJobId(this.$route.params.id)
    }
  },

  mounted () {
    axios.get('https://app2.gotland.se/jobblista/proxy2.php?job-id=' + this.$route.params.id)
      .then(resp => {
        this.job = resp.data

        this.$nextTick(() => {
          this.updateHeight()
        })
      })
      .catch(() => {
        this.job = null
        this.jobNotFound = true

        this.$nextTick(() => {
          this.updateHeight()
        })
      })
  }
}
</script>

<style scoped>
.job-content {
  max-width: 768px;
}

.top-image {
  aspect-ratio: 16/9;
  object-fit: cover;
  vertical-align: middle;
}

.share-icons a {
  margin-right: 15px;
}

.share-icons svg {
  height: 24px;
  fill: currentColor;
}
</style>
